// Chart colours aligned with NextJS consent-banners dashboard
// These vibrant colours work well in both light and dark modes
export const chartColors = [
	'#0088FE', // Bright Blue
	'#00C49F', // Teal/Cyan
	'#FFBB28', // Golden Yellow
	'#FF8042', // Orange
	'#8884d8', // Soft Purple
	'#82ca9d', // Soft Green/Mint
	'#ffc658' // Light Orange/Gold
]

// Semantic colours for button action charts (accept/reject/save patterns)
export const buttonActionColors = {
	acceptAll: '#22C55E', // Green
	rejectAll: '#EF4444', // Red
	save: '#3B82F6', // Blue
	autoSave: '#3B82F6', // Blue
	close: '#6B7280', // Gray
	manual: '#F59E0B' // Amber
}
